import { render } from "./addVoiceSampleDialog.vue?vue&type=template&id=22e64dfb&scoped=true"
import script from "./addVoiceSampleDialog.vue?vue&type=script&lang=js"
export * from "./addVoiceSampleDialog.vue?vue&type=script&lang=js"

import "./addVoiceSampleDialog.vue?vue&type=style&index=0&id=22e64dfb&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22e64dfb"]])

export default __exports__